import { turboproApiLista } from '@/api/turbopro';
import type { ListarRelatoriosFiltros, ListarRelatoriosResponse, RelatorioApi } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarRelatoriosApi(
  filtros: ListarRelatoriosFiltros = {}
): Promise<ListarRelatoriosResponse> {
  // POST com body, não GET com querystring — confirmado no Swagger real
  // (schema não tem CNPJ_Contribuinte, só os três campos abaixo).
  const resposta = await turboproApiLista<RelatorioApi>('Relatorios/ListarRelatorios', {
    method: 'POST',
    body: {
      TipoRelatorio: filtros.tipoRelatorio ?? '',
      TipoDocumento: filtros.tipoDocumento ?? '',
      EntradaSaida: filtros.entradaSaida ?? '',
    },
    headers: getRelatoriosHeaders(),
  });
  return resposta.data ?? [];
}
